import { render, staticRenderFns } from "./SchoolActivityModal.vue?vue&type=template&id=286a7516&scoped=true"
import script from "./SchoolActivityModal.vue?vue&type=script&lang=js"
export * from "./SchoolActivityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a7516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286a7516')) {
      api.createRecord('286a7516', component.options)
    } else {
      api.reload('286a7516', component.options)
    }
    module.hot.accept("./SchoolActivityModal.vue?vue&type=template&id=286a7516&scoped=true", function () {
      api.rerender('286a7516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/DynamicPublishing/modules/SchoolActivityModal.vue"
export default component.exports